import React from "react";
import { useQuery } from "@apollo/react-hooks";
import { gql } from "apollo-boost";
import { SelectButton, Loader } from "../StyledComponents";
import { ReactComponent as Check } from "../../svg/check.svg";
export const AddOns = ({ selected, handleClick }) => {
  const { loading, error, data } = useQuery(
    gql`
      query AddOns($id: Int!) {
        bedType(id: $id) {
          id
          addons {
            id
            title
            productThumbnail {
              url
              width
              height
            }
          }
        }
      }
    `,
    { variables: { id: selected.bed.id } }
  );
  if (loading) return <Loader />;
  if (error) return <p>Error :(</p>;

  let items = data.bedType ? [...data.bedType.addons] : null;

  if (!selected?.bedsidetable) {
    items = items.filter((item) => item.title !== "Table Lamp");
  }

  const itemHandler = (item_data, isActive) => {
    let active = selected.addons
      ? selected.addons.filter((addon) => {
          return addon.id !== item_data.id;
        })
      : [];

    if (item_data.title.indexOf("Tray") > -1) {
      active = active.filter((t) => t.title.indexOf("Tray") === -1);
    }

    if (isActive) {
      handleClick([...active]);
    } else {
      handleClick([...active, item_data]);
    }
  };

  return (
    <>
      {items &&
        items.map((item, i) => {
          const item_data = {
            id: parseInt(item.id),
            title: item.title,
          };
          const isActive = selected.addons
            ? selected.addons.find((addon) => addon.id === item_data.id) !==
              undefined
            : false;
          return (
            <SelectButton
              key={i}
              onClick={() => itemHandler(item_data, isActive)}
              className={isActive ? "active" : "inActive"}
            >
              <img
                loading="lazy"
                src={item.productThumbnail.url}
                alt=""
                height="90"
                width="90"
              />
              <h3>{item.title}</h3>
              <Check />
            </SelectButton>
          );
        })}
    </>
  );
};
